"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var IntegrationsModel = /** @class */ (function () {
    function IntegrationsModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/integrations",
        };
        this.data = [];
        this.cacheResults = this.cacheResults.bind(this);
        this.extract = this.extract.bind(this);
    }
    IntegrationsModel.prototype.extract = function (result) {
        return result.data;
    };
    IntegrationsModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    IntegrationsModel.prototype.show = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    IntegrationsModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        if (data !== null) {
            return this.$http
                .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data))
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    IntegrationsModel.prototype.downloadWordPressPlugin = function () {
        return this.$http.get(this.URLS.FETCH + "/wordpress/download", {
            responseType: "blob",
        });
    };
    return IntegrationsModel;
}());
IntegrationsModel.$inject = ["$http", "APPURL"];
exports.default = IntegrationsModel;
